/* eslint-disable max-lines */
import { Translation } from 'src/types';

const translations: Translation = {
  translation: {
    Buttons: {
      back: 'Terug',
      changePassword: 'Wachtwoord wijzigen',
      copiedVaultId: 'Gekopieerd!',
      copyVaultID: 'Kopieer Vault ID',
      create: 'Aanmaken',
      next: 'Volgende',
      notSure: 'Ik weet het niet zeker',
      signUp: 'Inschrijven',
      submit: 'Verzenden',
      updatePassword: 'Wachtwoord bijwerken',
    },
    Errors: {
      createReportFailed: 'Aanmaak melding mislukt.',
    },
    ReportStatus: {
      CLOSED: 'Afgesloten',
      INVESTIGATING: 'Wordt onderzocht',
      NEW: 'Verzonden',
      READ: 'Gelezen',
    },
    general: {
      navbar: {
        caseSettings: 'Hoesinstellingen',
        changePassword: 'Wachtwoord wijzigen',
        logOut: 'Uitloggen',
        notifications: 'Meldingen',
        notificationsDrawer: {
          appFileScanFailed:
            'Een bestand heeft de beveiligingscontrole niet doorstaan',
          appReportMatch: 'Uw GoTogether-record is gematcht',
          appReportReassigned: 'Een nieuwe casemanager is toegewezen',
          case: 'Zaak',
          caseAssigned: 'Zaak aan jou toegewezen',
          caseImporterJobCompleted: {
            PartialSuccess: 'Uw zaakimport is voltooid met fouten',
            failure: 'Uw zaakimport is mislukt',
            success: 'Uw zaakimport is succesvol voltooid',
          },
          caseLinked: 'Geval gekoppeld',
          caseTeamInvite: 'Toegevoegd aan zaak',
          caseUnlinked: 'Case ontkoppeld',
          dataSanitisation: 'Rapportdetails bijgewerkt',
          emptyDescription: 'Kom later terug voor nieuwe meldingen',
          emptyTitle: 'Je bent helemaal bij',
          importId: 'Importeer ID:',
          learnMore: 'Leer meer',
          markAllAsRead: 'Markeer alles als gelezen',
          newMessage: 'Nieuw bericht',
          newReport: 'Nieuw rapport ontvangen',
          permissionRemoved: 'Verwijderd uit zaak',
          postSSubmissionFile: 'Bewijsbestand(en) toegevoegd',
          report: 'Rapport',
          reportAssigned: 'Rapport aan u toegewezen',
          reportStatusChange: 'Rapportstatus gewijzigd',
          reporterAnonymised: 'Uw gegevens zijn geanonimiseerd',
          reporterReportSubmitted: {
            subtitle: 'We raden aan een kopie van uw rapport op te slaan',
            title: 'Ingediend rapport',
          },
          mitigationPlanReminder: 'Goedkeuring van het mitigatieplan vereist',
          staleCase: 'Onbehandelde zaak',
        },
        privacyStatement: 'Privacyverklaring',
        reporter: {
          myReports: 'Mijn rapporten',
        },
        settings: 'Instellingen',
        technicalSupport: 'Technische ondersteuning',
        title: 'Account',
      },
      time: {
        day: 'Dag',
        days: 'Dagen',
        hour: 'Uur',
        hours: 'Uren',
        minute: 'Minuut',
        minutes: 'Minuten',
        second: 'Seconde',
        seconds: 'Seconden',
      },
    },
    public: {
      ChatContainer: {
        anonymousLabel: 'Anoniem',
        autoTranslate: 'Auto-translate staat standaard uit.',
        backToMessages: 'Terug naar berichten',
        caseSettings: 'Instellingen voor de zaak.',
        changeInProfile:
          'Als u deze instelling wilt wijzigen, kunt u dit doen in uw profiel',
        deletedByMessage: 'Verwijderd door {{author}}',
        deletedMessageLabel: 'Dit bericht is verwijderd',
        description:
          'Wanneer automatische vertaling is ingeschakeld, worden alle rapportberichten automatisch vertaald met behulp van AI, gebaseerd op de standaardtaal die geselecteerd is in je browser.',
        descriptionSecondHalf:
          'De originele versie van alle berichten wordt altijd bewaard en kan worden gevonden in de chat.',
        messagePlaceholder: 'Begin met typen...',
        messageSettings: 'Berichtinstellingen.',
        originalMessages: 'Origineel',
        showMoreBanner: 'Leer meer over automatische vertalingen',
        titlev2: 'Lees alle berichten in je voorkeurstaal.',
        translatedMessageLabel: 'Vertaalde Bericht',
        translatedMessages: 'Vertaald',
        understood: 'Begrepen',
      },
      Country: {
        description: 'In welk land bent u gevestigd?',
        header: 'In welk land bent u gevestigd?',
        noOptions: 'Geen landen gevonden',
        other: 'Andere',
        placeholder: 'Zoek een land...',
      },
      CreatePublicReport: {
        createReport: 'Nieuwe melding aanmaken',
        helpPage: 'Ga naar onze helppagina',
        loginToOpr: 'Inloggen om rapporten te volgen',
        or: 'of',
        passwordPlaceholder: 'Wachtwoord invoeren',
        phoneNumberLoginFailed:
          'Inloggen mislukt, telefoonnummer/pin incorrect',
        phoneNumberPlaceholder: 'Voer uw telefoonnummer in',
        phoneNumberTooltip:
          'Voer het telefoonnummer in dat u heeft gebruikt om contact op te nemen met VaultTalk',
        pinPlaceholder: 'Voer pincode in',
        reportIntroductionParagraph1:
          'Bij het melden van een zorg worden er een paar vragen gesteld om je te ondersteunen bij het vastleggen van je ervaring.',
        reportIntroductionParagraph2:
          'Voordat je de melding indient, heb je de optie om anoniem te blijven om je privacy te beschermen.',
        reportIntroductionParagraph3:
          'Nadat je de melding hebt gedaan, kun je op elk moment inloggen om de voortgang van je melding te bekijken en met een casemanager te praten.',
        reportIssue: 'Een probleem melden',
        usernameLoginFailed:
          'Inloggen mislukt, gebruikersnaam/wachtwoord onjuist',
        validationError: {
          publicReport: {
            relationshipToCompanyRequired: 'Relatie tot het bedrijf is vereist',
            reportedCategoryRequired: 'Gerapporteerde categorie is vereist',
          },
        },
        vaultId: 'Vault ID',
        vaultIdPlaceholder: 'Voer uw e-mail of Vault ID in',
        vaultIdTooltip:
          'Voor anonieme rapporten is de Vault ID alfanumeriek. Als het rapport niet anoniem was, is de Vault ID uw e-mailadres.',
        vaultTalk: 'VaultTalk',
        yourPassword: 'Uw wachtwoord',
        yourPhoneNumber: 'Uw Telefoonnummer',
        yourPin: 'Uw 6-cijferige pin',
        yourVaultId: 'Uw Vault ID',
      },
      CustomHeader: {
        companyLogo: 'Bedrijfslogo',
        openReporting: 'Meldingen openen',
        userSettings: 'Gebruikersinstellingen',
      },
      Date: {
        approximateDescription:
          'Herinnert u zich bij benadering op welke datum de gebeurtenis plaatsvond?',
        approximatePlaceholder:
          'Voorbeeld: 6 maanden geleden / vorig jaar / vorige november',
        cancel: 'annuleren',
        clear: 'wissen',
        description:
          'Herinnert u zich op welke datum de gebeurtenis plaatsvond?',
        header: 'Op welke dag vond de gebeurtenis plaats?',
        ok: 'OK',
        placeholder: 'Voorbeeld: 21 juni 2020',
      },
      Description: {
        whatHappened: 'Wat is er gebeurd?',
        whatHappenedPlaceholder: 'Gebruik uw eigen woorden...',
        whatHappenedText: 'Beschrijf in je eigen woorden wat er is gebeurd.',
      },
      Details: {
        disclaimer:
          'Deze gegevens worden bij je melding gevoegd. Als je anoniem wilt blijven, zorg er dan voor dat ze geen identificerende informatie bevatten.',
        emailPlaceholder: 'E-mail (facultatief)',
        fullNamePlaceholder: 'Volledige naam (facultatief)',
        header: 'Jouw gegevens',
        nonAnonSubtitle:
          'Geef alstublieft uw naam of een e-mailadres op. Als u meldingen over dit rapport wilt ontvangen, voeg dan hieronder een geschikt e-mailadres toe.',
        nonOptionalEmailPlaceholder: 'E-mail',
        nonOptionalFullNamePlaceholder: 'Volledige naam',
        subtitle:
          'Als u meldingen over dit rapport wilt ontvangen, voeg dan hieronder een geschikt e-mailadres toe.',
      },
      Emotion: {
        description: 'Hoe voelde u zich daarbij? Wat was de impact?',
        header: 'Wat was de impact?',
        placeholder: 'Begin te typen ...',
      },
      Evidence: {
        addedHeading: 'Toegevoegd',
        deletedMessage: 'werd verwijderd',
        deletedStatus: 'Verwijderd',
        failedToOpenFileMessage:
          'Het openen van het bestand is mislukt. Probeer het opnieuw.',
        fileStatuses: {
          infectedUpload: 'Gemarkeerd door beveiligingscontrole',
          passedUpload: 'Geslaagd voor beveiligingscontrole',
          pendingUpload: 'Veiligheidscontrole in uitvoering',
          readyForDownload: 'Klaar voor download',
        },
        mobileErrorMessage:
          'Gemarkeerde bestanden: stuur een bericht naar uw casemanager',
        nameHeading: 'Naam',
        statusHeading: 'Status',
        tableTitle: 'Bewijs',
        webErrorMessage:
          'Gemarkeerde bestanden: Als uw bestand(en) zijn gemarkeerd, stuur dan een bericht naar de casemanager.',
      },
      FileUpload: {
        addFiles: 'Bestanden toevoegen',
        addMoreFiles: 'Voeg meer bestanden toe',
        confirm: 'Bevestigen',
        description:
          'Het toevoegen van bestanden als bewijs, kan de casemanager helpen bij het beoordelen van je melding. Controleer de inhoud van het bestand goed (ook de metadata) als je anoniem wilt blijven, en zorg dat je hierin toepasselijke wetgeving en de rechten van andere genoemde personen respecteert.',
        dragDrop: 'Sleep bestanden hierheen of',
        errorMessage:
          'Bestand(en) mislukt vanwege een netwerkfout. Klik hieronder om uw casemanager te berichten voor hulp.',
        fileLimit: 'Elke bestandsgrootte limiet: 100MB',
        fileUploadLimitText: 'Je kunt slechts 10 bestanden uploaden',
        header: 'Voeg bewijs toe',
        helpArticle: 'helpartikel',
        highlighted: 'bestanden doorbladeren',
        information: 'Ondersteunde bestandstypen',
        moreInformation:
          'Voor meer informatie, zie dit help-artikel <a>helpartikel</a>',
        postSubmissionErrorMessage:
          "We konden uw bestanden niet uploaden vanwege een systeemfout. Selecteer alstublieft opnieuw 'bevestigen'.",
        tooltipAudio: 'Audio:',
        tooltipAudioOptions: '.ogg, .wav, .wma',
        tooltipDocuments: 'Documenten:',
        tooltipDocumentsOptions:
          '.ps, .docx, .doc, .pptx, .ppt, .xlsx, .xls, .dcm, .pdf',
        tooltipImage: 'Afbeeldingen:',
        tooltipImageOptions:
          '.png, .apng, .jpg, .jpeg, .pjpeg, .svg, .gif, .tiff, .tif, .bmp, .psd, .avif',
        tooltipText: 'Tekst:',
        tooltipTextOptions: '.txt, .csv, .html, .xml',
        tooltipVideo: 'Video:',
        tooltipVideoOptions: '.mp4, .mov, .mp1s, .asf',
        uploadErrors: {
          invalidFileSize: 'Bestand is te groot',
          invalidFileType: 'Niet-ondersteund bestandstype: {{extension}}',
          systemError: 'Systeemfout',
          tooManyFiles: 'Maximum aantal bestanden is {{maxFiles}}',
        },
        uploadFiles: 'Bestanden uploaden',
      },
      Loading: {
        loading:
          'Even geduld terwijl we uw rapport indienen bij een casemanager...',
        postSubmissionLoading:
          'Even geduld terwijl we je bestand(en) indienen...',
      },
      Location: {
        description: 'Waar is het gebeurd?',
        header: 'Waar is het gebeurd?',
        placeholder: 'Voorbeeld: op kantoor',
      },
      MessageListBox: {
        messageCaseManager: 'Bericht aan case manager',
        report: 'Melding {{displayReportId}} {{submissionType}}',
      },
      MessageSettings: {
        enableTranslationLabelDisabled: 'Vertaling uitgeschakeld',
        enableTranslationLabelEnabled: 'Vertaling ingeschakeld',
        enableTranslationsDescription:
          'Schakel automatische vertalingen in en lees alle rapportberichten in uw voorkeurstaal. De vertaalde taal is gebaseerd op de taal die op uw apparaat is geselecteerd.',
        enableTranslationsHeader:
          'Schakel automatische vertalingen in voor rapportberichten',
        enableTranslationsSubDescriptionv2:
          'Je kunt in elke chat schakelen tussen de vertaalde en originele taal.',
        updateTranslationFailed: 'Update vertaling mislukt',
        updateTranslationSuccess: 'Vertaalinstellingen met succes bijgewerkt',
      },
      Password: {
        changePasswordHeader: 'Wachtwoord wijzigen',
        createNewPassword: 'Maak een nieuw wachtwoord',
        createPasswordHeader: 'Uw wachtwoord',
        currentPasswordPlaceholder: 'Voer huidig wachtwoord in',
        description:
          'Een geldig wachtwoord moet uit minstens 9 tekens bestaan en een hoofdletter en een cijfer bevatten.',
        enterCurrentPassword: 'Voer uw huidige wachtwoord in',
        forgottenPasswordInstructions:
          'Voer je alfanumerieke Vault ID in (niet je e-mailadres) en je e-mailadres om je wachtwoord te resetten.',
        newDescription:
          'Maak een sterk wachtwoord om uw account veilig te houden. Begin met typen om de richtlijnen hieronder te zien.',
        passwordPlaceholder: 'Wachtwoord aanmaken',
        passwordResetRequestedDescription:
          'Als uw Vault ID in ons systeem bestaat, ontvangt u een e-mail met instructies om uw wachtwoord te resetten.',
        passwordResetRequestedHeader:
          'Link voor het opnieuw instellen van het wachtwoord aangevraagd',
        reenterPlaceholder: 'Voer het wachtwoord opnieuw in',
        subtitle:
          'Maak een wachtwoord aan om deze melding in te dienen en ze later te kunnen raadplegen',
        yourVaultId: 'Uw Vault ID',
        yourVaultIdPlaceholder: 'Voer uw Vault ID in (bijv. {{exampleId}})',
      },
      Perpetrators: {
        description:
          'Meldt je over een specifieke persoon of meerdere personen? Kunt u hun naam geven of hen beschrijven?',
        header: 'Betrokken mensen',
        placeholder:
          'Begin te typen en gebruik een komma om meerdere namen of beschrijvingen toe te voegen',
      },
      PoweredByVault: 'Powered by {{company}}',
      PrivacyStatement: 'Product Privacyverklaring',
      PublicMessageList: {
        myMessages: 'Mijn berichten',
      },
      PublicMoreEvidence: {
        additionalEvidenceHeader: 'Bewijs toegevoegd aan bestaand rapport',
        backToReportId: 'Terug naar rapport ID: {{reportId}}',
        description:
          'Het toevoegen van bestanden als bewijs kan de efficiëntie van de oplossing door uw casemanager ondersteunen. Overweeg de inhoud van het bestand (inclusief bestandsmetadata) als u anoniem wilt blijven, en respecteer de rechten van andere individuen en toepasselijke wetten. Voor meer informatie, zie dit <a>helpartikel</a>',
        header: 'Voeg extra bewijs toe aan het rapport',
        vaultTalkOpenCaseHeader: 'Voeg bewijs toe aan je rapport',
      },
      PublicReport: {
        anonymous: 'Anoniem',
        backToReports: 'Terug naar meldingen',
        skipped: 'Overgeslagen',
      },
      PublicReportCard: {
        addEvidence: 'Voeg extra bewijs toe',
        messageCaseManager: 'Bericht aan case manager',
        reportId: 'ID van de melding:',
        submitted: 'Verzonden',
        vaultTalkClosedCaseCTA: 'Bekijk Bewijs',
        vaultTalkOpenCaseCTA: 'Voeg Bewijs Toe',
        viewAdditionalEvidence: 'Bekijk aanvullend bewijs',
        viewReport: 'Melding bekijken',
      },
      PublicReportsList: {
        reportingSystem: 'Meldingssysteem',
      },
      Question: {
        placeholder: 'Begin met typen...',
        question: 'Geef details',
        questionText: 'Deel a.u.b. uw zorg, update of vraag met ons.',
      },
      Relationship: {
        header: 'Uw relatie met de organisatie',
        tellUsAbout:
          'Wat is je relatie tot de organisatie waarover je de melding maakt?',
      },
      ResponsiveNavMenu: {
        messages: 'Mijn berichten',
        reports: 'Mijn rapporten',
      },
      Site: {
        description: 'Op welke locatie bent u gevestigd?',
        header: 'Op welke locatie bent u gevestigd?',
        noOptions: 'Geen locaties gevonden',
        other: 'Anders',
        placeholder: 'Zoek naar een locatie...',
      },
      SpamPuzzle: {
        dialog: 'Los deze puzzel op om verder te gaan',
      },
      SubmissionTypes: {
        reportIssue: 'Selecteer een categorie',
        whatType: 'Selecteer de categorie die je melding het beste beschrijft',
      },
      SubmitSuccess: {
        category: '<bold>Categorie:</bold> {{categorie}}',
        country: '<bold>Land:</bold> {{country}}',
        dateSubmitted: '<bold>Ingediende datum:</bold> {{date}}',
        recordYourVaultID: 'Onthoud deze informatie voor het inloggen',
        successInformation: 'Meer informatie',
        successMessage:
          'Uw rapport is ingediend en is klaar voor beoordeling. Alle bijgevoegde bestanden die aandacht vereisen, worden gemarkeerd bij het inloggen. Log hieronder in om rapportupdates te bekijken en uw casemanager een bericht te sturen.',
        successSanitationMessage:
          'Bewaar een kopie voor uw eigen administratie en bewaar uw Vault-ID veilig - u heeft deze nodig om updates te raadplegen en berichten te sturen naar uw casemanager.',
        successSanitationTagline:
          'Uw rapport is ingediend en veilig opgeslagen.',
        successThankYou: 'Bedankt voor uw rapport!',
        viewReport: 'Bekijk rapport',
      },
      Time: {
        approximateDescription:
          'Herinnert u zich bij benadering op welk tijdstip de gebeurtenis plaatsvond?',
        approximatePlaceholder: "Voorbeeld: 's ochtends, 's middags",
        description:
          'Herinnert u zich op welk tijdstip de gebeurtenis plaatsvond?',
        header: 'Op welk tijdstip vond de gebeurtenis plaats?',
        invalidTime: 'Tijdformaat moet UU:MM zijn',
      },
      UserSettingsDialog: {
        changePassword: 'Wachtwoord wijzigen',
        closeDialog: 'Dialoog sluiten',
        logout: 'Uitloggen',
        messageSettings: 'Berichtinstellingen',
        userSettings: 'Gebruikersinstellingen',
      },
      Witnesses: {
        description:
          'Hebt u dit aan iemand verteld of heeft iemand gezien wat er is gebeurd?',
        header: 'Waren er getuigen?',
        placeholder: 'Begin te typen ...',
      },
    },
    reporting: {
      MessageSlideIn: {
        confirmButton: 'Stuur bericht',
        title: 'Bericht Case Manager',
        translationHeader: 'Leer meer over automatische vertalingen',
      },
      ReportCard: {
        addEvidence: 'Voeg bewijs toe',
        submissionModeVia: 'via {{inzendingsmodus}}',
        viewEvidence: 'Bekijk bewijs',
      },
      ReportList: {
        yourReports: 'Uw Rapporten',
      },
      ReportingActivate: {
        buttonText: 'Doorgaan',
        description:
          'Als uw organisatie u heeft geregistreerd voor een account, sturen we u een e-mail met instructies om de installatie te voltooien.',
        emailInput: 'E-mail',
        header: 'Voer je werk e-mail in',
        successAccount:
          'Als uw organisatie u heeft geregistreerd voor een account, sturen we u een e-mail met instructies om de installatie te voltooien.',
        successEmail:
          'Als je het niet meteen ziet, wacht dan een paar minuten en ververs je e-mail inbox.',
        successHeading: 'Dank je',
      },
      ReportingAddEvidence: {
        descriptionHeader: 'Voeg bewijs toe aan je rapport',
        descriptionText:
          'Het toevoegen van bestanden als bewijs kan de efficiëntie van de oplossing door uw casemanager ondersteunen. Overweeg de inhoud van het bestand (inclusief bestandsmetadata) als u anoniem wilt blijven, en respecteer de rechten van andere personen en de toepasselijke wetten. Voor meer informatie, zie dit <a>help artikel</a>',
        emptyMessage: 'Geen aanvullend bewijs geüpload',
      },
      ReportingChangePassword: {
        back: 'Terug',
        description:
          'Maak een sterk wachtwoord om uw account veilig te houden. Begin met typen om de richtlijnen hieronder te zien.',
        errorToast: 'Kan geen wachtwoord aanmaken, ongeldige token.',
        header: 'Wachtwoord Wijzigen',
        incorrectCurrentPassword:
          'Het huidige wachtwoord is verkeerd. Controleer dit alstublieft en probeer het opnieuw.',
        invalidToken: 'Ongeldig teken',
        passwordUpdated: 'Wachtwoord bijgewerkt',
        passwordUpdatedDescription:
          'Uw wachtwoord is succesvol bijgewerkt. Bedankt voor het nemen van deze stap om uw gegevens veilig te houden!',
        passwordUsedBefore: 'Hergebruik van wachtwoord niet toegestaan',
        passwordUsedBeforeDescription:
          'Voor uw veiligheid kunt u geen van uw laatste zes wachtwoorden opnieuw gebruiken. Kies alstublieft een nieuw, uniek wachtwoord om uw account veilig te houden en probeer het opnieuw.',
        toastDescription:
          'Uw wachtwoord is succesvol bijgewerkt. Bedankt voor het nemen van deze stap om uw gegevens veilig te houden!',
        toastMessage: 'Wachtwoord bijgewerkt',
        updatePasswordCTA: 'Wachtwoord bijwerken',
      },
      ReportingConnect: {
        cancelButton: 'Annuleren',
        connectButton: 'Verbind',
        disclaimer:
          'Het koppelen van uw Slack-account aan uw Vault-account zorgt voor een veilige en privéverbinding.<br /><br />Door te koppelen, kunt u wangedrag melden of direct binnen Slack een vraag stellen. U heeft altijd de optie om anoniem te rapporteren na het koppelen. Uw privacy en veiligheid zijn onze hoogste prioriteiten.',
        heading:
          'Vault Platform vraagt toestemming om toegang te krijgen tot uw {{organisationName}} Slack-account',
        listHeading: 'Wat zal Vault kunnen doen?',
        permissionIdentity: {
          extraInfo:
            'Vault krijgt de mogelijkheid om de identiteit van uw Slack-gebruiker te bekijken',
          heading: 'Bekijk informatie over de identiteit van een gebruiker',
        },
        permissionNotifications: {
          extraInfo:
            'Vault kan meldingen naar je Slack-account sturen, over eventuele updates van een ingediend rapport of vraag',
          heading: 'Stuur je meldingen',
        },
        permissionOverview: {
          extraInfo:
            'Vault zal een overzicht van alle inzendingen weergeven op de startpagina',
          heading: 'Overzicht van inzendingen',
        },
        permissionSubmitReport: {
          extraInfo:
            'Dit geeft Vault toestemming om een rapport in te dienen of een vraag te stellen, rechtstreeks aan uw organisatie, vanuit Slack.',
          heading: 'Dien een rapport of vraag in namens jou',
        },
        successfulConnectionDescription:
          'Uw Vault-account en Slack-account zijn nu verbonden. Je kunt dit tabblad nu sluiten en terugkeren naar Slack.',
        successfulConnectionHeading: 'Succesvol verbonden',
        unsuccessfulConnectionDescription:
          'Er is iets misgegaan. Sluit dit tabblad alstublieft en ga terug naar Slack om het opnieuw te proberen.',
        unsuccessfulConnectionHeading: 'Verbinding mislukt',
      },
      ReportingForgotPassword: {
        description:
          'Voer het e-mailadres in dat is gekoppeld aan uw account, en we sturen u een link om uw wachtwoord te resetten.',
        heading: 'Vergeten wachtwoord',
        invalidTokenError: 'Kan geen wachtwoord aanmaken, ongeldig token.',
        passwordReuseError: 'Hergebruik van wachtwoord niet toegestaan',
        passwordReuseErrorDescription:
          'Voor uw veiligheid kunt u geen van uw laatste zes wachtwoorden opnieuw gebruiken. Kies alstublieft een nieuw, uniek wachtwoord om uw account veilig te houden en probeer het opnieuw.',
        sendLink: 'Stuur reset link',
        sendLinkFailure: 'Er is iets misgegaan',
        sendLinkFailureDescription:
          'Ga terug naar de <a>Reporter Hub</a> en probeer het opnieuw. Als het probleem aanhoudt, neem dan contact met ons op via <mailto>techsupport@vaultplatform.com</mailto>',
        sendLinkSuccess: 'Link voor wachtwoordreset verzonden',
        sendLinkSuccessDescription:
          'We hebben een link om je wachtwoord te herstellen gestuurd naar {{email}}',
        updatePasswordSuccess: 'Wachtwoord bijgewerkt',
        updatePasswordSuccessDescription:
          'Uw wachtwoord is met succes bijgewerkt. Bedankt voor het nemen van deze stap om uw gegevens veilig te houden!',
      },
      ReportingLogin: {
        accountFrozen: 'Account is bevroren',
        accountLocked:
          'Er is te vaak geprobeerd in te loggen met een onjuist wachtwoord. Het account is tot 1 uur vergrendeld. Het is niet mogelijk om het wachtwoord te resetten gedurende deze tijd.',
        accountLockedPermanently:
          'Uw account is vergrendeld. Gebruik wachtwoord resetten om opnieuw toegang te krijgen of neem contact op met uw systeembeheerder voor verdere hulp.',
        createAccountCTA: 'Registreer voor een account',
        currentPassword: 'Huidig Wachtwoord',
        emailLabel: 'Uw Email',
        forgotPassword: 'Wachtwoord vergeten?',
        loginButton: 'Inloggen',
        newPasswordPlaceholder: 'Nieuw wachtwoord',
        passwordFailMessage:
          'Ga terug naar de Vault App in Slack en probeer het opnieuw. Als het probleem aanhoudt, neem dan contact met ons op via techsupport@vaultplatform.com',
        passwordFailTitle: 'Er is iets misgegaan',
        passwordLabel: 'Uw Rassword',
        passwordPlaceholder: 'Voer uw wachtwoord in',
        passwordResetRequired: 'Wachtwoord reset vereist',
        passwordSuccessfullySetMessage:
          'Ga terug naar de Vault App in Slack en verifieer met je nieuwe wachtwoord om verder te gaan waar je gebleven was.',
        passwordSuccessfullySetTitle: 'Wachtwoord succesvol ingesteld',
        reenterPlaceholder: 'Voer wachtwoord opnieuw in',
        title: 'Reporter Hub',
        tooltip:
          'Als je nog nooit een wachtwoord hebt ingesteld voor de Vault-app, volg dan hier om te beginnen. Als je je wachtwoord bent vergeten, gebruik dan de link "Wachtwoord Vergeten" hieronder.',
        usernameLoginFailed:
          'Inloggen mislukt, gebruikersnaam of wachtwoord onjuist',
      },
      ReportingReset: {
        failureDescription:
          'Ga terug naar de Vault App in Slack en probeer het opnieuw. Als het probleem aanhoudt, neem dan contact met ons op via <mailto>techsupport@vaultplatform.com</mailto>',
        failureHeading: 'Er is iets misgegaan',
        successDescription:
          'Ga terug naar de Vault App in Slack en authenticeer met je nieuwe wachtwoord om verder te gaan waar je gebleven was',
        successHeading: 'Wachtwoord succesvol ingesteld',
      },
      noReports: {
        description:
          'Alle ingediende rapporten worden hier weergegeven. Leer meer over de manieren waarop je een rapport kunt indienen bij',
        descriptionHelpArticle: 'dit hulp artikel',
        errorDescription:
          'We hebben moeite om je rapporten te laden. Probeer de pagina te vernieuwen.',
        errorDescriptionSecondary:
          'Als dat niet werkt, neem dan alstublieft contact met ons op via',
        errorTitle: '⚠️ Oeps, er is iets misgegaan',
        title: 'Je hebt nog geen rapporten',
      },
      settings: {
        messageSettings: {
          autoTranslationDescription1:
            'Schakel automatische vertalingen in en lees alle rapportberichten in uw voorkeurstaal. De vertaalde taal is gebaseerd op de taal die op uw apparaat is geselecteerd.',
          autoTranslationDescription2:
            'Je kunt tussen de vertaalde en originele taal schakelen in elke chat.',
          autoTranslationTitle:
            'Schakel automatische vertalingen in voor rapportberichten',
          header: 'Berichtinstellingen',
          subHeader: 'Configureer hoe berichten worden weergegeven',
        },
        notificationSettings: {
          emailDescription:
            'Ontvang e-mailmeldingen voor belangrijke updates van uw rapporten',
          emailTitle: 'E-mail meldingen',
          header: 'Notificatie Instellingen',
          subHeader: 'Configureer hoe u meldingen ontvangt',
        },
        title: 'Instellingen',
        updatedSettingsFailure: 'Mislukt om uw instellingen bij te werken',
        updatedSettingsSuccess: 'Uw instellingen zijn succesvol bijgewerkt',
      },
    },
    validators: {
      passwordLength: 'Wachtwoord moet uit ten minste 9 tekens bestaan',
      passwordLowercase: 'Wachtwoord moet ten minste 1 kleine letter bevatten',
      passwordMissMatch:
        "De velden 'Wachtwoord' en 'Bevestiging' moeten overeenkomen.",
      passwordNumeric: 'Wachtwoord moet ten minste 1 cijfer bevatten',
      passwordUppercase: 'Wachtwoord moet ten minste 1 hoofdletter bevatten',
    },
    validatorsNew: {
      passwordLength: 'Tussen 10 en 30 karakters',
      passwordLowercase: 'Minstens één kleine letter',
      passwordMissMatch: 'Wachtwoorden komen niet overeen',
      passwordNumeric: 'Minstens één nummer',
      passwordSpecialCharacter: 'Ten minste één speciaal teken',
      passwordUppercase: 'Minstens één hoofdletter',
    },
  },
};

export default translations;
